import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";

class UsersCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            first: 0
        };
    }

    render() {
        const { pageSize, totalRecords, arraylist,t } = this.props;

        return (
            <div className="">
                {this.renderCardData()}
                {arraylist && arraylist.length ? (
                    <Paginator
                        className="mb-3"
                        first={this.state.first}
                        rows={pageSize}
                        totalRecords={totalRecords}
                        onPageChange={(e) => this.onPaginatorChange(e)}
                    ></Paginator>
                ) : (
                        <div
                            className="card"
                            style={{ overflow: "hidden", position: "relative" }}
                        >
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    !--{t("CommonText.NoItem")} --!
              </h6>
                            </div>
                        </div>
                    )}
            </div>
        );
    }
    onPaginatorChange(event) {
        const { setUpdatedState } = this.props;
        this.setState({ first: event.first });
        setUpdatedState(event.page + 1);
    }
    renderCardData = () => {
        const { showSidePane, arraylist, deleteUserList, eyeclick,t } = this.props;
        return arraylist && arraylist.length
            ? arraylist.map((item, index) => {
                return (
                    <div className="card mb-2" style={{ overflow: "hidden", position: "relative" }}>
                        <div className="p-2">
                            <div className="resource-list-auth-date">
                                <div className="row">
                                    <div className={showSidePane ? "col-sm-9 col6 m-auto" : "col-sm-10 col-md-11 col-10 m-auto"}>
                                        <div className="row px-4">
                                            <div className={showSidePane ? "col-sm-8" : "col-sm-6"}>
                                                <span>
                                                    <strong>{t("MMPLUserManagementContent.UserId")} : </strong>
                                                    <span className="italicFont ">
                                                        {item.email}
                                                    </span>
                                                </span>
                                            </div>
                                            {/* <div className={showSidePane ? "col-sm-4" : "col-sm-6"}>
                                                <span>
                                                    <strong>Is Admin : </strong>
                                                    <span className="italicFont ">
                                                        {item.isAdmin === true ? "True" : item.isAdmin === false ? "False" : ""}
                                                    </span>
                                                </span>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className={showSidePane ? "col-sm-3 col6 m-auto" : "col-sm-2 col-md-1 col-2 m-auto text-right"}>
                                        <div className={showSidePane ? "text-center" : "ml0 text-center"}>
                                            <i
                                                className="fa fa-edit click px-1"
                                                aria-hidden="true"
                                                onClick={() =>
                                                    eyeclick(item)
                                                }
                                                style={{ color: ' #1a3464', fontSize: "1.8rem" }}
                                            ></i>
                                            <i
                                                className="fa fa-trash click px-1"
                                                aria-hidden="true"
                                                style={{ color: ' #1a3464', fontSize: "1.8rem" }}
                                                onClick={() => deleteUserList(item)}
                                            ></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })
            : null;
    };
}
function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.sidePan || false,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withTranslation()(withRouter(
    connect(mapStateToProps, mapDispatchToProps)(UsersCard)));
